import { Component, Input, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { fileNameFromPath } from '../../utils/file-name-from-path.util';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() name: string;
  @Input() mandatory: boolean;
  @Input() helpTooltipText: string;
  @Input() accept = '*';
  private inputZoneHighlightClass = 'highlight';
  public value: string;

  get inputZoneId() {
    return `${this.id}-input-zone`;
  }

  get fileName() {
    return fileNameFromPath(this.value);
  }

  constructor(@Self() public controlDirective: NgControl) {
    controlDirective.valueAccessor = this;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched: any = () => {};

  public writeValue(value: string) {
    this.value = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public handleFileInputDragover() {
    const inputZoneElement = document.getElementById(this.inputZoneId);

    inputZoneElement.classList.add(this.inputZoneHighlightClass);
  }

  public handleFileInputDragleave() {
    const inputZoneElement = document.getElementById(this.inputZoneId);

    inputZoneElement.classList.remove(this.inputZoneHighlightClass);
  }

  public handleFileInputDrop() {
    const inputZoneElement = document.getElementById(this.inputZoneId);

    inputZoneElement.classList.remove(this.inputZoneHighlightClass);
  }

  public handleInput(event: any) {
    this.onChange(event);
  }
}
